// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { enablePostalCodeLocationFinder } from "@bg/App/Store/Selectors/PostalCodeSelector";
import { constants } from "@bg/XDL/constants";
import { hasLocalStorage } from "@bg/XDL/Utilities";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { getProductCollectionRealTimeInventory } from "@insite/client-framework/Services/ProductServiceV2";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";

export const XngRequestDataFromApi: typeof RequestDataFromApi = async props => {
    if (
        enablePostalCodeLocationFinder(props.getState()) &&
        !hasLocalStorage(constants.localStorage.POSTAL_CODE_ID) &&
        !props.getState().context.session.isAuthenticated
    ) {
        return;
    }

    if (!getSettingsCollection(props.getState()).productSettings.showInventoryAvailability) {
        return;
    }

    try {
        props.apiResult = await getProductCollectionRealTimeInventory(props.apiParameter);
    } catch (error) {
        logger.warn(`Failed to load inventory data: ${error}`);
        props.error = error;
    }
};

replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);
